import { render } from "./AprVegas.vue?vue&type=template&id=e5114cc8"
import script from "./AprVegas.vue?vue&type=script&lang=js"
export * from "./AprVegas.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__